import { get as getProperty, set } from 'lodash';

function mergeSingleDataIntoArray(
  oldData,
  newData,
  arrayKey,
  singleKey,
  idKey,
  addStrategy = 'unshift'
) {
  let mergedData = [];
  if (
    oldData &&
    getProperty(oldData, arrayKey) &&
    getProperty(oldData, arrayKey).length
  ) {
    const oldArray = getProperty(oldData, arrayKey);

    // find matching data in oldData array
    const index = oldArray.findIndex(
      data => data[idKey] === newData[singleKey][idKey]
    );

    // clone the array
    mergedData = oldArray.slice(0);

    // we found a match, replace the data at the found index
    if (index >= 0) {
      mergedData[index] = newData[singleKey];
    } else {
      // we didn't find one so add the new data
      if (addStrategy === 'push') {
        mergedData.push(newData[singleKey]);
      } else {
        mergedData.unshift(newData[singleKey]);
      }
    }
  } else {
    // old data was empty, so the new data will be the only thing in the array
    mergedData = [newData[singleKey]];
  }
  const data = oldData ? { ...oldData } : {};
  return set(data, arrayKey, mergedData);
}

export default mergeSingleDataIntoArray;
